import { useLang } from '@/app/utils/useLang';

export const useIntroductionList = (locale: string, active: string) => {
    const { t } = useLang('membersday.membersdayintroduction25');
    const listA = [
        {
            pc:
                locale === 'jp'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1742904401287/jp-1.jpg'
                    : 'https://websiteoss.ecoflow.com/upload/image/1741874117494/ecoflow01.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1741874117494/ecoflow01.jpg',
            title: t('introduction_card1_title'),
            desc: t('introduction_card1_text'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1741874132290/ecoflow02.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1741874132290/ecoflow02.jpg',
            title: t('introduction_card2_title'),
            desc: t('introduction_card2_text'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1741874151817/ecoflow03.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1741874151817/ecoflow03.jpg',
            title: t('introduction_card3_title'),
            desc: t('introduction_card3_text'),
        },
    ];

    const listB = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1741874048218/ecocredits01.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1741874048218/ecocredits01.jpg',
            title: t('introduction_card4_title'),
            desc: t('introduction_card4_text'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1741874088931/ecocredits02.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1741874088931/ecocredits02.jpg',
            title: t('introduction_card5_title'),
            desc: t('introduction_card5_text'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1741874102303/ecocredits03.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1741874102303/ecocredits03.jpg',
            title: t('introduction_card6_title'),
            desc: t('introduction_card6_text'),
        },
    ];

    return active === 'a' ? listA : listB;
};
